import { useState, useEffect } from 'react';
import Localization from "../Localization";
import i18n from "i18n-js";

const useLocalization = () => {
    const [local, setLocal] = useState<typeof i18n | null>(null);

    useEffect(() => {
        const fetchData = async () => {
            const newLocal = await Localization("en");
            setLocal(newLocal);
        };

        fetchData();
    }, []);

    return local;
}

export default useLocalization;